import { fieldDomId } from './missingFields.js';

/** Where to go when a field is not on this page: the Review step's "needs attention" list, then the error summary. */
export const FIELD_FALLBACK_IDS = ['review-outstanding', 'registration-error-summary'];

const FOCUSABLE =
  'input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Scrolls a field to the middle of the screen and puts focus in it. A wrapper (a verification
 * panel, a group of controls) hands focus to its first control. A disabled input is scrolled to
 * but cannot take focus. Returns false when neither the field nor a fallback is on the page.
 */
export function focusField(key, fallbackIds = FIELD_FALLBACK_IDS) {
  if (typeof document === 'undefined') return false;
  const target =
    (key && document.getElementById(fieldDomId(key))) ||
    fallbackIds.map((id) => document.getElementById(id)).find(Boolean);
  if (!target) return false;

  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

  const control = target.matches(FOCUSABLE)
    ? target
    : target.querySelector(FOCUSABLE) || (target.hasAttribute('tabindex') ? target : null);
  control?.focus({ preventScroll: true });
  return true;
}
